import styled from 'styled-components';

export const MatchedTitle = styled.h3`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8f95b2;
  margin: unset;
  margin-bottom: 4px;
`;

export const MatchedToWrapper = styled.div`
  grid-gap: 16px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #1371fe;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 2fr 3fr 3fr 1fr 2fr;
  align-items: center;
  grid-gap: 16px;
`;

export const MatchedItem = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const NoText = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-style: italic;
`;

export const MatchedImage = styled.img`
  width: 32px;
  height: 32px;
`;
